import { styled, Grid } from '@shared/components';

export default styled(Grid)(({ theme }) => ({
  padding: theme.spacing(4),
  gap: theme.spacing(6),
  gridTemplateColumns: '1fr 1fr',
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.shape.rounded(4),
  border: `1px solid ${theme.palette.grey[300]}`,
  width: '100%',
}));
